// require("./lib/pym");

require("imagesloaded");
require("signals");
const _ = require("underscore");
const hasher = require("hasher");
const unveil = require("jquery-unveil");
var dot = require("./lib/dot");

var story_modal = dot.compile(require("./_modal_template.html"));

$(document).ready(function() {
  var $items = $("#items");
  var itemsLength = $(".item").length;
  var $container = $("#items");
  var previous = "";

  // init
  $container.isotope({
    // options
    itemSelector: ".item",
    layoutMode: "masonry"
  });

  $container.imagesLoaded().progress(function() {
    $container.isotope("layout");
  });

  var iso = $container.data("isotope");

  // Handles filter based on main category buttons
  $("div.button-container > button.category").click(function() {
    var $parent = $(this).parent();
    var filters = [];
    var directory = "";
    var selector = "";

    $(this).toggleClass("active inactive");

    // if ($(this).hasClass('active')) {
    //     $(this).removeClass("active");
    //     $(this).addClass("inactive");
    // } else {
    //     $(this).addClass("active");
    //     $(this).removeClass("inactive");
    // }

    $("div.button-container > button.category.active").each(function() {
      var filter = $(this).attr("data-filter");
      if ($.inArray(filter, filters) == -1) {
        filters.push($(this).attr("data-filter"));
      }
    });

    selector = filters.join(",");
    if (filters.length > 0) {
      directory = "tag";
    }

    hasher.setHash(directory, selector);
  });

  // Handles filter based on selected category
  $(".selected").click(function() {
    var $parent = $(this).parent();
    var filters = [];
    var directory = "";

    $(this).toggleClass("active inactive");

    // if ($(this).hasClass('active')) {
    //     $(this).removeClass("active");
    //     $(this).addClass("inactive");
    // } else {
    //     $(this).addClass("active");
    //     $(this).removeClass("inactive");
    // }

    $(".active").each(function() {
      var filter = $(this).attr("data-filter");
      if ($.inArray(filter, filters) == -1) {
        filters.push($(this).attr("data-filter"));
      }
    });

    selector = filters.join(",");
    if (filters.length > 0) {
      directory = "tag";
    }

    hasher.setHash(directory, selector);
  });

  // Shows story modal on item click
  $(".item").click(function() {
    selector = $(this).attr("id");
    directory = "story";
    hasher.setHash(directory, selector);
  });

  $(".clear-filters").click(function() {
    $("button.category,.categories").removeClass("active inactive");
    hasher.setHash("_");
  });

  $(".back-to-top").click(function() {
    document.querySelector(".headline-container").scrollIntoView({
      behavior: "smooth"
    });
  });

  $("#filters-buttons").on("hide.bs.collapse", function() {
    $(".fas.fa-chevron-right").toggleClass("rotate");
  });

  $("#filters-buttons").on("show.bs.collapse", function() {
    $(".fas.fa-chevron-right").toggleClass("rotate");
  });

  // Toggle filter collpase on large screens
  $("#filters-buttons").toggleClass("show", $(window).width() > 600);

  $(".filter-by > i").toggleClass("rotate", $(window).width() > 600);

  $(".random").click(function() {
    // clear filters, otherwise modal navigation crashes the page
    hasher.setHash("_");

    num = Math.floor(Math.random() * (itemsLength + 1));
    selector = $(".item")
      .eq(num)
      .attr("id");
    directory = "story";
    hasher.setHash(directory, selector);
  });

  $("#myModal").on("hidden.bs.modal", function(e) {
    if (previous == "") {
      previous = "_";
    }

    hasher.setHash(previous);
  });

  function handleChanges(newHash, oldHash) {
    // remove any active tags
    $("button.category,.categories,.person").removeClass("active");

    // save previous oldHash globally for modal
    if (oldHash) {
      if (oldHash.split("/")[0] != "story") {
        previous = oldHash;
      }
    }

    // get attributes from newHash
    var hashArray = hasher.getHashAsArray();
    var directory = hashArray[0];
    var tagString = hashArray[1];
    var tags = [];
    var tagsArray = [];

    // create tagsArray and tags class filters
    if (tagString) {
      tagsArray = hashArray[1].split(",");
      for (var i in tagsArray) {
        tags[i] = "." + tagsArray[i];
      }
      filter = tags.join("");
    }

    // parse directory and then filter as needed
    if (directory == "tag") {
      $(".active-filters").html("for ");
      $("button.category").addClass("inactive");

      for (var i in tagsArray) {
        var prettyTag = $(
          "button[data-filter='" +
            tagsArray[i] +
            "'],.person[data-filter='" +
            tagsArray[i] +
            "']"
        )
          .first()
          .text();
        $(
          "button[data-filter='" +
            tagsArray[i] +
            "'],.person[data-filter='" +
            tagsArray[i] +
            "']"
        ).addClass("active");
        $(
          "button[data-filter='" +
            tagsArray[i] +
            "'],.person[data-filter='" +
            tagsArray[i] +
            "']"
        ).removeClass("inactive");
        $(".clear-filters").html(
          'Clear All <i class="fa fa-times-circle"></i>'
        );

        $(".active-filters").append(
          '<span class="category selected ' +
            tagsArray[i] +
            '" data-filter="' +
            tagsArray[i] +
            '">' +
            prettyTag.trim() +
            "</span>"
        );
      }

      $items.isotope({
        filter: filter
      });

      var count =
        'Currently displaying <span class="count">' +
        iso.filteredItems.length +
        '</span> of <span class="count">' +
        itemsLength +
        "</span> stories";
      $(".count-filters").html(count);
    } else if (directory == "story") {
      // var story = _.find(DATA, function (item) {
      //     return item == tagString;
      // });
      var story_details = DATA[tagString];
      $("#myModal .modal-body").empty();
      $("#myModal .modal-body")[0].innerHTML = story_modal({
        story: story_details
      });

      $("#myModal").modal("show");

      // modal navigation

      currentFilterItems = [];

      iso.getFilteredItemElements().forEach(function(d) {
        currentFilterItems.push(d.id);
      });

      while (tagString != currentFilterItems[0]) {
        currentFilterItems.push(currentFilterItems.shift());
      }

      // if only one story in filter, hide the arrows

      if (currentFilterItems.length == 1) {
        $(".controlArrow").hide();
      } else {
        nextStory = currentFilterItems[1];
        prevStory = currentFilterItems[currentFilterItems.length - 1];

        $(".controlArrow.next").click(function() {
          hasher.setHash("story", nextStory);
        });
        $(".controlArrow.prev").click(function() {
          hasher.setHash("story", prevStory);
        });
      }

      // end modal navigation

      // category buttons on modal

      $(".modal-categories .btn.category").click(function() {
        category = $(this).attr("data-filter");

        previous = "tag/" + category;

        cat_selector = "button.category." + category;

        $(cat_selector).toggleClass("active inactive");

        $("#myModal").modal("toggle");
      });

      // end category buttons on modal
    } else {
      var count =
        'Currently displaying all <span class="count">' +
        itemsLength +
        "</span> stories";
      $(".count-filters").html(count);
      $(".active-filters").html("");
      $(".clear-filters").html("");
      $items.isotope({
        filter: "*"
      });
    }
  }

  $container.isotope("on", "arrangeComplete", function(filteredItems) {
    $("#noresults").hide();
    if (filteredItems.length == 0) {
      $("#noresults").show();
    } else {
      $("#noresults").hide();
    }

    filteredItems.forEach(item => {
      selector = "#" + item.element.id;

      $(selector)
        .find("img")
        .trigger("unveil");
    });
  });

  var filters_offset = $(".filter-text").height();

  // $('#filters').affix({
  //     offset: {
  //         top: $('.active-filters').offset().top-$('.filter-text').height()
  //     }
  // });

  // var controller = new ScrollMagic.Controller();

  // var scene = new ScrollMagic.Scene({
  //         triggerElement: "#filters-container",
  //         triggerHook: 'onLeave',
  //     })
  //     .setPin("#filters-container")
  //     // .addIndicators({name: "2 (duration: 0)"}) // add indicators (requires plugin)
  //     .addTo(controller);

  // // collapses filters when pinned to the top, storing collapse state before pin. Sets collapse state to that when scrolling back to the top
  // var filtersVisible;
  // scene.on("enter", function (event) {
  //     filtersVisible = $('#filters-buttons').is( ":visible" );
  //     $('#filters-buttons').collapse('hide');
  // });

  // // show filters when user scrolls to the top
  // scene.on("leave", function (event) {
  //     if (filtersVisible) {
  //         $('#filters-buttons').collapse('show');
  //     } else {
  //         $('#filters-buttons').collapse('hide');
  //     }
  // });

  hasher.changed.add(handleChanges); //add hash change listener
  hasher.initialized.add(handleChanges); //add initialized listener (to grab initial value in case it is already set)
  hasher.init(); //initialize hasher (start listening for history changes)

  $("img").unveil(200, function() {
    $(this).removeClass("lazy");
    $(this).on("load", function() {
      $container.isotope("layout");
    });
  });

  // $(window).trigger("lookup");

  // // var test_id="watch-and-or-read-a-handmaid-s-tale"
  // // console.log(_.find(ITEMS, function(item) {
  // //     return item.TaskCategory.TaskCategoryId == $routeParams.TaskCategory;
  // // }));

  // // Clipboard function on share sheet

  $(".clippy").on("click", function() {
    // copy the hyperlink to the clipboard
    $("#summary-text").select();
    document.execCommand("copy");
    $(".clippy").tooltip("show");
    setTimeout(hideTooltip, 1000);

    function hideTooltip() {
      $(".clippy").tooltip("hide");
    }
  });

  // var setupClipboardjs = function () {
  //     var clipboard = new Clipboard('.clippy');
  //     clipboard.on('success', function (e) {
  //         e.clearSelection();
  //         $(e.trigger).tooltip('show');
  //         setTimeout(hideTooltip, 1000);

  //         function hideTooltip() {
  //             $(e.trigger).tooltip('hide');
  //         }
  //     });
  //     clipboard.on('error', function (e) {
  //         console.log('Your browser does not support execCommand. Press Ctrl/Cmd+C to copy');
  //         $(e.trigger).attr('data-original-title', 'Press Ctrl/Cmd+C to copy');
  //         $(e.trigger).tooltip('show');
  //         setTimeout(hideTooltip, 1000);

  //         function hideTooltip() {
  //             $(e.trigger).tooltip('hide');
  //         }
  //     });
  // }

  // $('[data-toggle="tooltip"]').tooltip();
  // setupClipboardjs();
});
